const HisTrendingDown = ({ color, sx }) => {
  const strokeColor = color ?? "#0B4EDB";
  const _sx = sx ?? {};

  return (
    <svg
      style={_sx}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill="white" />
      <path
        d="M27.949 21.5105L17.324 10.8855L11.074 17.1355L2.949 9.01047"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4492 21.5106H27.9492V14.0106"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisTrendingDown;
